import { COMMON } from '@locales/id/messages';
import { Banner } from './Banner';
import { Button } from './Button';

export function ErrorState({ error, onRetry }: { error: string | null; onRetry?: () => void }) {
  if (!error) return null;
  return (
    <Banner tone="error" action={onRetry && <Button size="sm" onClick={onRetry} icon="refresh">{COMMON.retry}</Button>}>
      {error}
    </Banner>
  );
}
